import React from 'react';
import { ClinicalTranslationStatus } from '../../models/BackendModels';

interface Props {
    original: string;
    english?: string | null;
    german?: string | null;
    sourceLanguage?: string | null;
    status?: ClinicalTranslationStatus | null;
}

interface Entry {
    language: 'Original' | 'English' | 'German';
    text: string;
    translated: boolean;
}

const ClinicalTextEntries: React.FC<Props> = ({ original, english, german, sourceLanguage, status }) => {
    let entries: Entry[] = [{ language: 'Original', text: original, translated: false }];
    const reliableLanguage = sourceLanguage === 'mixed' ||
        (!!sourceLanguage && sourceLanguage !== 'und' && /^[a-z]{2,3}$/.test(sourceLanguage));
    const completeEnglish = sourceLanguage === 'en' && english == null && !!german?.trim();
    const completeGerman = sourceLanguage === 'de' && german == null && !!english?.trim();
    const completeOther = sourceLanguage !== 'en' && sourceLanguage !== 'de' &&
        !!english?.trim() && !!german?.trim();

    if (status === 'complete' && reliableLanguage && (completeEnglish || completeGerman || completeOther)) {
        entries = [
            ...(sourceLanguage === 'en' || sourceLanguage === 'de' ? [] : entries),
            {
                language: 'English',
                text: sourceLanguage === 'en' ? original : english!,
                translated: sourceLanguage !== 'en',
            },
            {
                language: 'German',
                text: sourceLanguage === 'de' ? original : german!,
                translated: sourceLanguage !== 'de',
            },
        ];
    }

    return (
        <dl className="diagnosis-context__entries">
            {entries.map(({ language, text, translated }) => (
                <div className="diagnosis-context__entry" key={language}>
                    <dt>
                        {language}
                        {translated && (
                            <span className="diagnosis-context__translation-badge">Machine translated</span>
                        )}
                    </dt>
                    <dd>{text}</dd>
                </div>
            ))}
        </dl>
    );
};

export default ClinicalTextEntries;
